/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_LoadingInputs */

const en_dashboard_loading = /** @type {(inputs: Dashboard_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading your workspace tasks…`)
};

const pt_br2_dashboard_loading = /** @type {(inputs: Dashboard_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando suas atividades…`)
};

/**
* | output |
* | --- |
* | "Loading your workspace tasks…" |
*
* @param {Dashboard_LoadingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const dashboard_loading = /** @type {((inputs?: Dashboard_LoadingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_LoadingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dashboard_loading(inputs)
	return pt_br2_dashboard_loading(inputs)
});